import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Busy busy busy",
  "description": "",
  "published": "2007-04-17T00:00:00.000Z",
  "redirect_from": ["/blog/busy-busy-busy/swizec/230"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Å½e od nedelje vroÄiÄno ustvarjam seminarsko nalogo za raÄunalništvo, ki mi pripomore 20% k oceni na maturi. Rok za oddajo je Äez nekaj dni, kar je verjetno razlog za tako zazveto delo ... oz. sploh delo. Trenutno naloga premore 20 strani in se bo verjetno še za nekaj strani zredila. Potem pa seveda pridejo obvezna branja in popravki, kot z vsakim pisanjem v bistvu.`}</p>
    <p>{`Kot ste, ali niste, opazili, novega stripa ni bilo Å¾e od januarja, kar je skoraj tri mesece in seveda se zavedam, da za take neumnosti pravzaprav ni opraviÄila. Ampak mi `}<em parentName="p">{`je`}</em>{` res Å¾al, resno, da mi je. Å½alostna resnica za tem nedolÅ¾nim prestopkom je poveÄana koliÄina truda za šolo, ker si nikakor ne morem privošÄiti, da ne bi bil spušÄen na maturo. Letos je potrebno s šolo opraviti lepo, kot se zagre in zakljuÄiti to poglavje v Å¾ivljenju. Poleg tega imam še sluÅ¾bo, ki jo opravljam vsak dan po pouku in oÄitno je, da to ne pusti veliko Äasa za delo na stripu. Obljubim, da bom naredil vse v svoji moÄi, da bo na strani nov strip do konca meseca.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      